import(/* webpackMode: "eager" */ "/app/app/(app)/shop/cart/page.tsx");
